// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.feedback-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  
  justify-content: right;
  
  align-items: center;
  z-index: 1000;
}

.feedback-form-container {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px; /* Adds consistent spacing between form elements */
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

.close-button:hover {
  color: #565454;
}

.feedback-form h2 {
  margin-bottom: 20px;
  font-size: 1.5rem;
  text-align: center; /* Center the heading */
  font-weight: bold;
}

.feedback-form label {
  display: block;
  font-weight: bold;
  margin-bottom: 8px;
  text-align: left;
}

.feedback-form input,
.feedback-form textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  margin-bottom:10px;
  
}

.feedback-form textarea {
  resize: none;
}

.rating {
  display: flex;
  align-items: left;
  flex-direction: column;
  gap: 10px; /* Space between label and stars */
}

.stars {
  display: flex;
  
  gap: 10px; /* Space between stars */
  justify-content: left; /* Center align the stars */
  margin-bottom: 10px;
}

.star {
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
}

.star.filled {
  color: #ffc107;
}

.star:hover,
.star.filled:hover ~ .star {
  color: #ffc107;
}

.submit-button {
  width: 100%; /* Ensures the button spans the container */
  padding: 10px;
  background: #4caf50;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  text-align: center;
}

.submit-button:hover {
  background: #45a049;
}

.feedback-success {
  text-align: center;
}

.feedback-success h2 {
  margin-bottom: 20px;
  font-size: 1.5rem;
}


/* Mobile View (Responsive Design) */
@media (max-width: 768px) {
  .feedback-form-container {
    height: auto;
    width: 65%; /* Shrinks the form width for smaller screens */
    padding: 20px; /* Adjusts padding for smaller screens */
    gap: 10px; /* Reduce spacing between form elements */
    margin-right: 10%;
  }

  .close-button {
    font-size: 20px; /* Smaller close button */
    top: 5px;
    right: 5px;
  }

  .feedback-form h2 {
    font-size: 1.25rem; /* Slightly smaller heading */
    margin-bottom: 15px;
  }

  .feedback-form input,
  .feedback-form textarea {
    padding: 8px; /* Smaller padding */
    font-size: 14px; /* Adjust font size for inputs and textarea */
  }

  .star {
    font-size: 20px; /* Adjust star size */
  }

  .submit-button {
    font-size: 14px; /* Smaller button text */
    padding: 8px; /* Smaller padding */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Feedbackform/Feedbackform.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;;EAEb,sBAAsB;;EAEtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,kDAAkD;AAC/D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB,EAAE,uBAAuB;EAC3C,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,SAAS,EAAE,kCAAkC;AAC/C;;AAEA;EACE,aAAa;;EAEb,SAAS,EAAE,wBAAwB;EACnC,qBAAqB,EAAE,2BAA2B;EAClD,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA,oCAAoC;AACpC;EACE;IACE,YAAY;IACZ,UAAU,EAAE,+CAA+C;IAC3D,aAAa,EAAE,wCAAwC;IACvD,SAAS,EAAE,yCAAyC;IACpD,iBAAiB;EACnB;;EAEA;IACE,eAAe,EAAE,yBAAyB;IAC1C,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,kBAAkB,EAAE,6BAA6B;IACjD,mBAAmB;EACrB;;EAEA;;IAEE,YAAY,EAAE,oBAAoB;IAClC,eAAe,EAAE,6CAA6C;EAChE;;EAEA;IACE,eAAe,EAAE,qBAAqB;EACxC;;EAEA;IACE,eAAe,EAAE,wBAAwB;IACzC,YAAY,EAAE,oBAAoB;EACpC;AACF","sourcesContent":["\n.feedback-form-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  \n  justify-content: right;\n  \n  align-items: center;\n  z-index: 1000;\n}\n\n.feedback-form-container {\n  background: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  width: 400px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 15px; /* Adds consistent spacing between form elements */\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #333;\n  cursor: pointer;\n}\n\n.close-button:hover {\n  color: #565454;\n}\n\n.feedback-form h2 {\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n  text-align: center; /* Center the heading */\n  font-weight: bold;\n}\n\n.feedback-form label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 8px;\n  text-align: left;\n}\n\n.feedback-form input,\n.feedback-form textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n  margin-bottom:10px;\n  \n}\n\n.feedback-form textarea {\n  resize: none;\n}\n\n.rating {\n  display: flex;\n  align-items: left;\n  flex-direction: column;\n  gap: 10px; /* Space between label and stars */\n}\n\n.stars {\n  display: flex;\n  \n  gap: 10px; /* Space between stars */\n  justify-content: left; /* Center align the stars */\n  margin-bottom: 10px;\n}\n\n.star {\n  font-size: 24px;\n  color: #ccc;\n  cursor: pointer;\n}\n\n.star.filled {\n  color: #ffc107;\n}\n\n.star:hover,\n.star.filled:hover ~ .star {\n  color: #ffc107;\n}\n\n.submit-button {\n  width: 100%; /* Ensures the button spans the container */\n  padding: 10px;\n  background: #4caf50;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  text-align: center;\n}\n\n.submit-button:hover {\n  background: #45a049;\n}\n\n.feedback-success {\n  text-align: center;\n}\n\n.feedback-success h2 {\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n}\n\n\n/* Mobile View (Responsive Design) */\n@media (max-width: 768px) {\n  .feedback-form-container {\n    height: auto;\n    width: 65%; /* Shrinks the form width for smaller screens */\n    padding: 20px; /* Adjusts padding for smaller screens */\n    gap: 10px; /* Reduce spacing between form elements */\n    margin-right: 10%;\n  }\n\n  .close-button {\n    font-size: 20px; /* Smaller close button */\n    top: 5px;\n    right: 5px;\n  }\n\n  .feedback-form h2 {\n    font-size: 1.25rem; /* Slightly smaller heading */\n    margin-bottom: 15px;\n  }\n\n  .feedback-form input,\n  .feedback-form textarea {\n    padding: 8px; /* Smaller padding */\n    font-size: 14px; /* Adjust font size for inputs and textarea */\n  }\n\n  .star {\n    font-size: 20px; /* Adjust star size */\n  }\n\n  .submit-button {\n    font-size: 14px; /* Smaller button text */\n    padding: 8px; /* Smaller padding */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
